// extracted by mini-css-extract-plugin
export default {"applicationsContainer":"Applications_applicationsContainer__ABq22","createAppButton":"Applications_createAppButton__uC9Km","appLoader":"Applications_appLoader__JXpt0"};